<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
    mixins: [Api, Sabit],
    props: ["DonemId", "IcKontrolDonemId", "Donemler"],
    components: {
        Loader
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
            },
            TableData: {},
            DonemAdi: "",
            loading: true,
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId() {
            this.Get();
        },
    },
    methods: {
        Get() {
            let Filter = "&DonemId=" + this.IcKontrolDonemId + "&UstDonemId=" + this.DonemId;
            this.ActionsFilterGet({ Service: "StrRaporlama/GetSoruFormuEylemBazli", Page: this.Page, Filter: Filter }).then((res) => {
                this.TableData = res.Data.Tanimlar;
                for (var Donem in this.Donemler) {
                    if (this.Donemler[Donem].Id == this.IcKontrolDonemId) {
                        this.DonemAdi = this.Donemler[Donem].Aciklama
                    }
                }


            });

        },
        ExcelExport(table, name) {
            if (!table.nodeType) table = this.$refs.veriGiris;
            var html = table.innerHTML
            var ctx = { worksheet: name || 'Worksheet', table: html }
            var a = document.createElement('a');
            a.href = this.uri + this.base64(this.format(this.template, ctx));
            a.download = name + '.xls';
            a.click();
        },
        ToplamPuan(Data) {
            if (Data.length > 0) {
                var toplamPuan = 0;
                for (var i = 0; i < Data.length; i++) {
                    toplamPuan += Data[i].Puan
                }
            }
            return toplamPuan;
        },
        KurumOrtalama(Data) {
            if (Data.length > 0) {
                var ortalama = 0;
                var toplamPuan = 0;
                for (var i = 0; i < Data.length; i++) {
                    toplamPuan += Data[i].Puan
                }
                ortalama = toplamPuan / Data.length
            }
            return ortalama.toFixed(2);
        },
        ToplamKanit(Data) {
            if (Data.length > 0) {
                var toplamKanit = 0;
                for (var i = 0; i < Data.length; i++) {
                    toplamKanit += Data[i].KanitSayisi
                }
            }
            return toplamKanit;
        }

    },
    computed: {},
    created() {
        this.Get();
    },
};
</script>
<template>
    <Loader>
        <div>
            <div class="text-sm-end">
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                        'Soru Formu Sonuçları (Eylem Bazlı)',
                        'Soru Formu Sonuçları (Eylem Bazlı)',
                    )
                ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Excel'e Aktar
                </button>
            </div>
            <div ref="veriGiris" class="table-responsive">
                <div class="table-responsive">
                    <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                        <tr>
                            <td colspan="8" class="h5"
                                style="text-align: center;border-color: #0049B7; border-style: solid; font-family: Arial; display: block;">
                                Soru Formu Sonuçları (Eylem Bazlı) <br>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="table-responsive" v-for="(Data, index) in TableData" :key="index">
                                    <table class="table table-striped table-bordered mb-0" v-if="Data.Birimler != null">
                                        <thead>
                                            <tr style="background-color: #0049B7;">
                                                <th colspan="4" class="col-md-6">{{ Data.Eylem }}</th>
                                                <th colspan="4" style="text-align: center;">{{ DonemAdi }}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(Birim, index) in Data.Birimler" :key="index">
                                            <tr>
                                                <td colspan="4">{{ Birim.BirimAdi }}</td>
                                                <td colspan="4" style="text-align: center;">{{ Birim.Puan }}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-bordered mb-0" v-if="Data.Birimler != null">
                                        <tbody>
                                            <tr>
                                                <th colspan="4" class="col-md-6">Toplam Puan</th>
                                                <td colspan="4" style="text-align: center;">{{
                                                    ToplamPuan(Data.Birimler)
                                                }}</td>
                                            </tr>
                                            <tr>
                                                <th class="col-md-6" colspan="4">Kanıt Sayısı</th>
                                                <td colspan="4" style="text-align: center;">{{
                                                    ToplamKanit(Data.Birimler)
                                                }}</td>
                                            </tr>
                                            <tr>
                                                <th class="col-md-6" colspan="4">Kurum Bazlı Ortalama</th>
                                                <td colspan="4" style="text-align: center;">{{
                                                    KurumOrtalama(Data.Birimler)
                                                }}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                    <br /><br />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </Loader>
</template>
